var exports = {
  "aP": "animatedVideoContainer__CtmfBM",
  "uL": "animatedVideoPlayer__6mvRpO",
  "Wl": "animatedVideoPlayerButton__F7AmgD",
  "CJ": "playButtonIcon__gpWHyv",
};

module.exports = exports;
